import React, { useEffect } from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { Color, globalFontStyle, globalStyle } from "../../../assets";
import HowToContest from "../childComponents/HowToContest";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import CustomButton from "../../../commonComponents/CustomButton";
import CommonModal from "../../../commonComponents/commonModal";
import TimerComp from "../../../commonComponents/TimerComp";
import {
  blue_coin,
  coin,
  contest_percentage,
  contest_smiley,
  contest_trophy,
} from "../../../utils/images";
import FastImage from "../../../common/FastImage";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {convert} from "../../../locale/translateText";
import {getLoginRoute} from "../../../utils/commonMethods";
import {useNavigation} from "@react-navigation/native";

const ContestAboutBox = ({
  contestDetail,
  setJoinContest,
  contestBalanceData,
  activeContest,
  isNewFormat,
  isAppLogin,
  navigation
}) => {
  const [topUpPopUp, setTopUpPopUp] = React.useState(false);
  const onTopUpClose = () => {
    setTopUpPopUp(false);
  };

  useEffect(() => {
    if (contestBalanceData?.error && activeContest) {
      setTopUpPopUp(true);
    }
  }, [contestBalanceData]);

  const closedChildRow = (
    <View style={{ flexDirection: "row" }}>
      <View style={{ flexDirection: "row", marginRight: 5 }}>
        <FastImage
          style={{ width: 15, height: 15 }}
          source={contest_percentage()}
        />
        <FormTextLabel
            labelStyles={{
              ...globalFontStyle.appFontSmallText,
              color: Colors.lightgrey,
            }}
            label={"Credits Won: "}
        >
          <Text style={{ color: Color.green }}>
            {contestDetail?.prize
                ? parseInt(contestDetail?.prize)
                : contestDetail?.prize}
          </Text>
        </FormTextLabel>
      </View>
      <View style={{ flexDirection: "row", gap: 5 }}>
        <FastImage
          style={{ width: 18, height: 18, bottom: 2 }}
          source={coin()}
        />
        <FormTextLabel
            labelStyles={{
              ...globalFontStyle.appFontSmallText,
              color: Colors.lightgrey,
            }}
            label={"Final Coin Balance: "}
        >
          <Text style={{ color: Color.green }}>
            {contestDetail?.final_wallet_amount
                ? parseInt(contestDetail?.final_wallet_amount)
                : contestDetail?.final_wallet_amount || 0}
          </Text>
        </FormTextLabel>
      </View>
    </View>
  );

  return (
    <View>
      <View
        style={{
          marginTop: 20,
          marginHorizontal: 15,
          marginBottom: activeContest ? -25 : 0,
          borderRadius: 8,
          borderWidth: 0.75,
          borderColor: Colors.borderColor,
        }}
      >
        <View style={styles.topContainer}>
          {/*{activeContest && (*/}
          {/*  <ParticipantsBlock*/}
          {/*    participants_no={contestDetail?.number_of_participants}*/}
          {/*  />*/}
          {/*)}*/}
          <Text style={{ ...globalFontStyle.appFontHeading, marginBottom: 5 }}>
            {contestDetail?.title}
          </Text>
          <FormTextLabel
            onPress={() => {
              setTopUpPopUp(true);
            }}
            labelStyles={{
              ...globalFontStyle.appFontSubText,
              color: Color.tradexBlue,
            }}
            label={"Learn More"}
          />
        </View>
        <View style={styles.bottomContainer}>
          {/*<View style={{ flex: 1 }}>*/}
          {/*  <Text*/}
          {/*    style={[*/}
          {/*      globalFontStyle.appFontSubText,*/}
          {/*      { color: Colors.lightgrey },*/}
          {/*    ]}*/}
          {/*  >*/}
          {/*    Prize Pool*/}
          {/*  </Text>*/}
          {/*  <Text*/}
          {/*    style={{*/}
          {/*      ...globalFontStyle.appBlueHead,*/}
          {/*      color: Colors.black,*/}
          {/*      marginTop: 5,*/}
          {/*    }}*/}
          {/*  >*/}
          {/*    {contestDetail?.prize_pool}*/}
          {/*  </Text>*/}
          {/*</View>*/}
          {/*{activeContest &&*/}
          {/*  Date.parse(contestDetail?.start_time) < Date.now() &&*/}
          {/*  Date.parse(contestDetail?.end_time) > Date.now() && (*/}
          {/*    <Text*/}
          {/*      style={{*/}
          {/*        paddingHorizontal: 10,*/}
          {/*        paddingVertical: 5,*/}
          {/*        backgroundColor: Colors.red,*/}
          {/*        color: Colors.bgWhite,*/}
          {/*        borderRadius: 5,*/}
          {/*        ...globalFontStyle.appFontSmallText,*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      Live*/}
          {/*    </Text>*/}
          {/*  )}*/}
          {/*<View style={{ flex: 1, alignItems: "flex-end" }}>*/}
          {/*  <TouchableOpacity*/}
          {/*    onPressIn={() => {*/}
          {/*      setTimeout(() => {*/}
          {/*        setTopUpPopUp(true);*/}
          {/*      }, globalConst?.buttonTimer);*/}
          {/*    }}*/}
          {/*    delayPressIn={0}*/}
          {/*    activeOpacity={0.8}*/}
          {/*    style={styles.topUpBtn}*/}
          {/*  >*/}
          {/*    <Text*/}
          {/*      style={{*/}
          {/*        ...globalFontStyle.appFontBody,*/}
          {/*        color: Colors.black,*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      How It Works?*/}
          {/*    </Text>*/}
          {/*  </TouchableOpacity>*/}
          {/*</View>*/}
          <FormTextLabel
              labelStyles={{
                ...globalFontStyle.appFontSubText,
                color: Color.tradexBlue,
              }}
              label={contestDetail?.is_participant
                  ? "Coins Balance"
                  : "Coins you’ll get"}
          />
          <View style={{ flexDirection: "row" }}>
            <FastImage
              style={{ width: 18, height: 18, marginRight: 5 }}
              source={blue_coin()}
            />
            <Text
              style={{
                ...globalFontStyle.appFontSubHeading,
                color: Colors.tradexBlue,
              }}
            >
              {!activeContest
                ? contestDetail?.final_wallet_amount || 0
                : contestDetail?.is_participant
                ? contestBalanceData?.coins
                : contestDetail?.virtual_credits}
            </Text>
          </View>
        </View>
        {activeContest && !contestDetail?.is_participant && (
          <>
            {/*{contestDetail?.is_participant ? (*/}
            {/*  <CustomButton*/}
            {/*    btnText={"Joined"}*/}
            {/*    btnType={"btnBlack"}*/}
            {/*    onBtnClick={() => {}}*/}
            {/*    customStyle={{*/}
            {/*      ...styles.buttonDesign,*/}
            {/*      backgroundColor: Colors.tradexBlue,*/}
            {/*    }}*/}
            {/*  />*/}
            {/*) : (*/}
            <CustomButton
              btnText={
              isAppLogin ?
                  (contestDetail?.entry_fee == 0
                  ? "JOIN FOR FREE"
                  : contestDetail?.entry_fee
                  ? convert("Join @ ") + contestDetail?.entry_fee
                  : "Join @ - ")
                  : "Sign up now to join the contest"
              }
              btnType={"btnBlack"}
              onBtnClick={() => {
                if (!isAppLogin) {
                  navigation.navigate(getLoginRoute())
                }
                else {
                  setJoinContest(true);
                }
              }}
              customStyle={[
                styles.buttonDesign,
                contestDetail?.entry_fee == 0 && {
                  backgroundColor: Colors.orange,
                },
              ]}
              translate={true}
            />
            {/*)}*/}
          </>
        )}
        {activeContest ? (
          <TimerComp
            start_time={contestDetail?.start_time}
            end_time={contestDetail?.end_time}
            isHome={"contestDetails"}
            customStyle={styles.timerIndicator}
            type={contestDetail?.contest_type}
            // percentage={contestDetail?.winner_percentage}
            noTimer={!!activeContest}
            isNewFormat={isNewFormat}
            participant={contestDetail?.number_of_participants}
          >
            {closedChildRow}
          </TimerComp>
        ) : (
          <View
            style={[
              styles.status,
              contestDetail?.prize > 0 ? { backgroundColor: "#E7FFF2" } : {},
            ]}
          >
            <FastImage
              style={{ width: 15, height: 15, marginRight: 8 }}
              source={
                contestDetail?.prize > 0 ? contest_trophy() : contest_smiley()
              }
            />
            <FormTextLabel
                labelStyles={{
                  ...globalFontStyle.appFontSubText,
                  color: contestDetail?.prize > 0 ? Colors.green : Colors.black,
                }}
                label={contestDetail?.prize > 0
                    ? "Congratulations! You have won "
                    : "Chins up! Roll it up again"}
                rest={{prize: contestDetail?.prize ? parseInt(contestDetail?.prize) : contestDetail?.prize}}
            />
          </View>
        )}
      </View>
      {/*<CommonModal*/}
      {/*  onModalCallBack={onTopUpClose}*/}
      {/*  customModalStyle={[globalStyle.modalView, { paddingTop: 0 }]}*/}
      {/*  showModal={topUpPopUp}*/}
      {/*>*/}
      {/*  <HowToContest*/}
      {/*    isBottomSheet={true}*/}
      {/*    isShowCTA={false}*/}
      {/*    coinsTobeAdded={contestBalanceData?.coinsTobeAdded}*/}
      {/*  />*/}
      {/*</CommonModal>*/}
      <CommonModal
        onModalCallBack={onTopUpClose}
        customModalStyle={[
          globalStyle.modalView,
          { alignItems: "stretch", paddingTop: 0 },
        ]}
        showModal={topUpPopUp}
      >
        <View style={{ paddingVertical: 20, paddingHorizontal: 15 }}>
          <Text
            style={{ ...globalFontStyle.appFontSubHeading, marginBottom: 5 }}
          >
            {contestDetail?.title}
          </Text>
          <Text
            style={{
              ...globalFontStyle.appFontHeadingRegular,
              color: Color.black,
            }}
          >
            {contestDetail?.description}
          </Text>
          <CustomButton
            btnText={"Okay"}
            btnType={"btnBlack"}
            onBtnClick={onTopUpClose}
            customStyle={{ flex: 1, marginTop: 20 }}
            translate={true}
          />
        </View>
      </CommonModal>
    </View>
  );
};

export default ContestAboutBox;

const styles = StyleSheet.create({
  timerIndicator: {},
  tabText: {
    ...globalFontStyle.appFontSubHeading,
    color: Color.black2,
    textAlign: "center",
  },
  tipTimerTestStyle: {
    ...globalFontStyle.appFontSubText,
    color: Color.blue1,
  },
  headerOption: {
    paddingHorizontal: 15,
    height: 40,
    marginRight: 10,
  },
  topUpBtn: {
    backgroundColor: Colors.bgWhite,
    borderColor: Colors.black,
    paddingHorizontal: 15,
    borderRadius: 5,
    borderWidth: 0.75,
    paddingVertical: 10,
    flexDirection: "row",
    alignItems: "center",
  },
  headerOptionsSelected: {
    backgroundColor: Colors.black,
  },
  modalView: {
    backgroundColor: "white",
    paddingHorizontal: 0,
    paddingTop: 16,
    paddingBottom: 0,

    position: "absolute",
    width: Width.width,

    bottom: 0,
    alignItems: "stretch",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 6,
  },
  topContainer: {
    backgroundColor: Colors.tradexBlue1,
    paddingHorizontal: 15,
    paddingVertical: 15,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  bottomContainer: {
    paddingHorizontal: 15,
    marginVertical: 15,
    marginHorizontal: 15,
    paddingVertical: 10,
    borderRadius: 8,
    backgroundColor: Colors.tradexBlue1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  status: {
    backgroundColor: "#E9E9E9",
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingVertical: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingHorizontal: 15,
  },
  buttonDesign: {
    flex: 1,
    marginTop: 0,
    marginHorizontal: 15,
    marginBottom: 15,
    paddingVertical: 15,
  },
});
